export class LazyLoad {

    constructor(target = '.js-lazy', options = {}) {

        this.target = target
        this.lazyImages = Array.from(document.querySelectorAll(target));

        this.options = {
            observer: {
                root: document.querySelector('body'),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }

        this.lazyImageObserver = new IntersectionObserver((entries, observer) => {
            this.load(entries, this)
        });

    }

    init() {
        this.lazyImages.forEach((lazyImage) => {
            this.lazyImageObserver.observe(lazyImage);
        });
    }

    load(entries, instance) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const lazyImage = (entry.target instanceof HTMLImageElement) ? entry.target : entry.target.querySelector('img');
                const image = new Image;

                image.onload = () => {
                    if(lazyImage.dataset.src) {
                        lazyImage.src = lazyImage.dataset.src;
                    }
                    if(lazyImage.dataset.srcset) {
                        lazyImage.srcset = lazyImage.dataset.srcset;
                    }
                    entry.target.classList.add('js-lazy--loaded');
                    instance.lazyImageObserver.unobserve(lazyImage);
                }

                if(lazyImage.dataset.src) {
                    image.src = lazyImage.dataset.src;
                } else {
                    entry.target.classList.add('js-lazy--loaded');
                    instance.lazyImageObserver.unobserve(lazyImage);
                }

            }
        });
    }
}
